import React from 'react';
import { Building2, Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export function SiteAreasSection({ siteAreas, onAdd, onEdit, onDelete }) {
    return (
        <div className="space-y-6" data-testid="welcome-site-areas">
            <div className="flex justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold">Site Areas</h2>
                    <p className="text-muted-foreground text-sm mt-1">
                        Manage the key areas displayed in the Welcome Guide
                    </p>
                </div>
                <Button onClick={onAdd} className="bg-teal-600 hover:bg-teal-700" data-testid="add-site-area-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Area
                </Button>
            </div>

            <div className="space-y-3">
                {siteAreas.map((area) => (
                    <div key={area.id} className="card-base" data-testid={`site-area-card-${area.id}`}>
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-lg bg-teal-100 flex items-center justify-center flex-shrink-0">
                                <Building2 className="w-6 h-6 text-teal-600" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h3 className="font-semibold">{area.title}</h3>
                                <p className="text-sm text-muted-foreground line-clamp-1">{area.description}</p>
                            </div>
                            <div className="flex items-center gap-2">
                                <Button variant="ghost" size="sm" onClick={() => onEdit(area)} data-testid={`edit-site-area-${area.id}`}>
                                    <Pencil className="w-4 h-4" />
                                </Button>
                                <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50" onClick={() => onDelete(area)} data-testid={`delete-site-area-${area.id}`}>
                                    <Trash2 className="w-4 h-4" />
                                </Button>
                            </div>
                        </div>
                    </div>
                ))}
                {siteAreas.length === 0 && (
                    <div className="text-center py-12 text-muted-foreground">
                        <Building2 className="w-12 h-12 mx-auto mb-3 opacity-50" />
                        <p>No site areas configured. Default areas will be shown.</p>
                        <Button onClick={onAdd} className="mt-4" variant="outline">
                            <Plus className="w-4 h-4 mr-2" />
                            Add Your First Area
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SiteAreasSection;
